<template>
    <div>

        <div class="cell example example1 p-4 rounded" id="example-1">
            <div class="card-body">
                <h3 class="card-title text-white"><strong>WeBase Pro, $9/month</strong> <i class="me-2 fas fa-rocket"></i></h3>
            </div>

            <form>
                <fieldset>
                    <div class="row">
                        <div id="example1-card"></div>
                    </div>
                </fieldset>
                <button type="submit" class="btn btn-success text-white" data-tid="elements_examples.form.pay_button">
                    Subscribe
                </button>
                <div class="card-body error mt-2" role="alert">
                    <span class="message"></span>
                </div>
            </form>
        </div>

    </div>
</template>

<script>
    import CreditCardService from "../services/CreditCardService";

    export default {
        name: 'PaymentForm',
        props: ['prop1', 'prop2'],
        data() {
            return {
                model: webase.model,
                stripe: null
            }
        },
        mounted() {
            this.stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
            let elements = this.stripe.elements()
            let card = elements.create('card', {
                hidePostalCode: true,
                iconStyle: 'solid',
                style: {
                    base: {
                        iconColor: '#c4f0ff',
                        color: '#fff',
                        fontWeight: 500,
                        fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                        fontSize: '16px',
                        fontSmoothing: 'antialiased',

                        ':-webkit-autofill': {
                            color: '#fce883',
                        },
                        '::placeholder': {
                            color: '#87BBFD',
                        },
                    },
                    invalid: {
                        iconColor: '#fbd3cd',
                        color: '#fbd3cd',
                    },
                },
            });
            card.mount('#example1-card');

            this.registerElements([card], 'example1');

        },
        methods: {
            registerElements(elements, exampleName) {
                var formClass = '.' + exampleName;
                var example = window.document.querySelector(formClass);

                var form = example.querySelector('form');
                var error = form.querySelector('.error');
                var errorMessage = error.querySelector('.message');

                function enableInputs() {
                    Array.prototype.forEach.call(
                        form.querySelectorAll(
                            "input[type='text'], input[type='email'], input[type='tel']"
                        ),
                        function (input) {
                            input.removeAttribute('disabled');
                        }
                    );
                }

                function disableInputs() {
                    Array.prototype.forEach.call(
                        form.querySelectorAll(
                            "input[type='text'], input[type='email'], input[type='tel']"
                        ),
                        function (input) {
                            input.setAttribute('disabled', 'true');
                        }
                    );
                }

                function triggerBrowserValidation() {
                    // The only way to trigger HTML5 form validation UI is to fake a user submit
                    // event.
                    var submit = document.createElement('input');
                    submit.type = 'submit';
                    submit.style.display = 'none';
                    form.appendChild(submit);
                    submit.click();
                    submit.remove();
                }

                // Listen for errors from each Element, and show error messages in the UI.
                var savedErrors = {};
                elements.forEach(function (element, idx) {
                    element.on('change', function (event) {
                        if (event.error) {
                            error.classList.add('visible');
                            savedErrors[idx] = event.error.message;
                            errorMessage.innerText = event.error.message;
                        } else {
                            savedErrors[idx] = null;

                            // Loop over the saved errors and find the first one, if any.
                            var nextError = Object.keys(savedErrors)
                                .sort()
                                .reduce(function (maybeFoundError, key) {
                                    return maybeFoundError || savedErrors[key];
                                }, null);

                            if (nextError) {
                                // Now that they've fixed the current error, show another one.
                                errorMessage.innerText = nextError;
                            } else {
                                // The user fixed the last error; no more errors.
                                error.classList.remove('visible');
                            }
                        }
                    });
                });

                // Listen on the form's 'submit' handler...
                form.addEventListener('submit', (e) => {
                    e.preventDefault();

                    // Trigger HTML5 validation UI on the form if any of the inputs fail
                    // validation.
                    var plainInputsValid = true;
                    Array.prototype.forEach.call(form.querySelectorAll('input'), function (
                        input
                    ) {
                        if (input.checkValidity && !input.checkValidity()) {
                            plainInputsValid = false;
                            return;
                        }
                    });
                    if (!plainInputsValid) {
                        triggerBrowserValidation();
                        return;
                    }

                    // Show a loading screen...
                    example.classList.add('submitting');

                    // Disable all inputs.
                    disableInputs();

                    // Gather additional customer data we may have collected in our form.
                    // var name = form.querySelector('#' + exampleName + '-name');
                    // var address1 = form.querySelector('#' + exampleName + '-address');
                    // var city = form.querySelector('#' + exampleName + '-city');
                    // var state = form.querySelector('#' + exampleName + '-state');
                    // var zip = form.querySelector('#' + exampleName + '-zip');
                    // var additionalData = {
                    //     name: name ? name.value : undefined,
                    //     address_line1: address1 ? address1.value : undefined,
                    //     address_city: city ? city.value : undefined,
                    //     address_state: state ? state.value : undefined,
                    //     address_zip: zip ? zip.value : undefined,
                    // };

                    // Use Stripe.js to create a token. We only need to pass in one Element
                    // from the Element group in order to create a token. We can also pass
                    // in the additional customer data we collected in our form.
                    this.model.loading = true

                    this.stripe.createToken(elements[0]).then( (result) => {
                        // Stop loading!
                        example.classList.remove('submitting');

                        if (result.token) {
                            // If we received a token, show the token ID.
                            // example.querySelector('.token').innerText = result.token.id;
                            // example.classList.add('submitted');


                            let cardService = new CreditCardService()
                            cardService.create(result).then( (cardResult) => {
                                console.log('result successful')
                                console.log(cardResult)
                                this.$emit('subscribeSuccessful')
                                this.model.loading = false

                            }).catch((error) => {
                                console.log('result error')
                                console.log(error)
                                let errorMessageText = error[0]
                                errorMessage.innerText = errorMessageText
                                this.model.loading = false
                            })

                        } else {
                            // Otherwise, un-disable inputs.
                            enableInputs();
                            this.model.loading = false
                        }
                    });
                });
            }
        }
    }
</script>
